import $ from 'jquery';
import { isValidEmail } from 'scripts/tools/validation';

class BankContactForm {
    constructor(formIdString) {
        this.$form = $('#' + formIdString);
        this.$nameInput = this.$form.find('.js-name');
        this.$emailInput = this.$form.find('.js-email');
        this.$feedbackMessageSuccess = this.$form.find('.js-success-message');
        this.$feedbackMessageError = this.$form.find('.js-error-message');
        this.$button = this.$form.find('.js-submit-btn');
        this.buttonText = this.$button.text();
        this.buttonBusyText = this.$button.attr('data-busy-text');
        this.$formGroupWrapper = this.$form.find('.form-group-wrapper');
        
        this.validationRules = {
            'name': value => value !== '',
            'GDPRCheckbox': value => value !== '' && (this.$form.find('.js-gdpr').is(":checked")),
            'email': value => value && (isValidEmail(value)),
        };

        this.$button.click((ev) => { this.submitClick(ev); });
        this.$form.on('change', 'input, textarea', this.onChange.bind(this));
    }

    onChange(event) {
        const input = event.currentTarget;
        const isValid = this.validationRules[input.name](input.value);
        this.setValidationState($(input), isValid);
    }

    setValidationState($input, isValid) {
        const $formGroup = this.getFormGroup($input);

        if (!this.$feedbackMessageSuccess.hasClass('hidden')) {
            this.$feedbackMessageSuccess.addClass('hidden').attr('aria-hidden', true);
        }

        if (isValid) {
            $formGroup.addClass('has-success');
            $formGroup.removeClass('has-error');
        } else {
            $formGroup.addClass('has-error');
            $formGroup.removeClass('has-success');
        }
    }

    getFormGroup($input) {
        return $input.closest('.form-group');
    }

    validateAll() {
        return Object.keys(this.validationRules).reduce((prev, inputName) => {
            const input = this.$form.find(`[name="${inputName}"]`);
            const predicate = this.validationRules[inputName];
            const valid = predicate(input.val());
            this.setValidationState($(input), valid);
            return prev && valid;
        }, true);
    }

    submitClick(event) {
        event.preventDefault();

        if (this.validateAll()) {
            this.$button.attr('disabled', 'disabled').text(this.buttonBusyText);
            this.$feedbackMessageError.addClass('hidden').attr('aria-hidden', true);
            this.$feedbackMessageSuccess.addClass('hidden').attr('aria-hidden', true);

            this.postContactForm().then(() => {
                this.$feedbackMessageSuccess.removeClass('hidden').attr('aria-hidden', false);
                this.clearFormOnSuccess();
                this.$button.addClass('hidden').attr('aria-hidden', true);
                this.$formGroupWrapper.addClass('hidden').attr('aria-hidden', true);
            }, () => {
                this.$feedbackMessageError.removeClass('hidden').attr('aria-hidden', false);
            }).always(() => {
                this.$button.removeAttr('disabled').text(this.buttonText);
            });
        }
    }

    clearFormOnSuccess() {
        const inputs = this.$form.find('input, textarea');
        inputs.each((i) => {
            $(inputs[i]).val('').closest('.form-group').removeClass('has-success');
        });
    }

    postContactForm() {
        const serializedArray = this.$form.serializeArray();
        const formData = {};

        serializedArray.forEach((input) => {
            formData[input.name] = input.value;
        });
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'event': 'form_submitted' });
        formData.currentPageUrl = window.location.href;
        return $.post('/api/contactcampaign/sendcontactcampaign', formData, {});
    }
}

export const init = (formIdString) => {
    return new BankContactForm(formIdString);
};
